// Main editor content
export const selectCurrentEditorContent = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.currentEditorContent;
export const selectAdditionalEditorContent = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.additionalEditorContent;
export const selectCurrentEditorId = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.currentEditorId;
export const selectCurrentEditorText = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.currentEditorText;

// Loadings
export const selectCurrentEditorLoading = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.currentEditorLoading;
export const selectSaveEditorLoading = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.saveEditorLoading;
export const selectPreviewVersionContentLoading = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.previewVersionLoading;

// Versions
export const selectEditorVersions = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.editorVersions;
export const selectCurrentEditorVersion = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.currentEditorVersion;
export const selectCurrentVersionId = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.currentEditorVersion?.id;
export const selectEditorPreviewVersion = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.previewVersion;

// Specific Optimizer
export const selectOptimizerCurrentVersionImportedUrl = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.optimizer?.currentVersionImportedUrl;

// Specific Outline
export const selectOutlineEditorNewTitleContent = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.outline?.editorNewTitleContent;

/**
 * @param {*} state
 * @returns {object} basicData object or undefined
 */
export const selectEditorBasicData = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.basicData;

// Settings
export const selectEditorHtmlTags = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.htmlTags;
export const selectEditorFullWidth = (editorType) => (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.[editorType]?.fullWidth;
export const selectEditorHighlightKeywords = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.highlightKeywords;
export const selectEditorTableOfContents = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.tableOfContents;
export const selectOptimizerTableOfContentsItems = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.tableOfContentsItems;

// AI
export const selectGeneratedAIToken = (state) =>
    state.contentOptimizer?.contentOptimizerEditor?.generatedAIToken;
export const selectAIState = (state) => state.contentOptimizer?.contentOptimizerEditor?.aiState;
export const selectAIStateLoading = (state) =>
    state.contentOptimizer?.contentOptimizerEditor?.aiState.isLoading;
export const selectAIStateResponse = (state) =>
    state.contentOptimizer?.contentOptimizerEditor?.aiState.response;
export const selectAIStateAccepted = (state) => {
    const aiState = state.contentOptimizer?.contentOptimizerEditor?.aiState;
    const aiSpellCheckerVisible =
        state.contentOptimizer?.contentOptimizerEditor?.aiSpellCheckerVisible;

    return !aiState?.response && !aiState?.isLoading && !aiSpellCheckerVisible;
};
export const selectAISpellCheckerVisible = (state) =>
    state.contentOptimizer?.contentOptimizerEditor?.aiSpellCheckerVisible;
export const selectAIOptimizerId = (state) =>
    state?.contentOptimizer?.contentOptimizerEditor?.aiState?.optimizerId;
